var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDpn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.441 16.371l2.172-3.76M27.187 24.527l-3.776 6.536-1.68 2.908a6.92 6.92 0 11-11.985-6.923l5.202-8.907"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M26.196 24.453L14.948 18.14l.639-1.204 4.639-8.029a6.92 6.92 0 1111.985 6.923l-3.525 6.101-1.692 2.929-.799-.407z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 26.394,
    cy: 9.732,
    r: 1.218
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDpn);
export default __webpack_public_path__ + "static/media/DPN.72d58bf3e2e2dc2fed582bb18c02b444.svg";
export { ForwardRef as ReactComponent };